import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getParentUrl } from '../../utils/browser';
import {
  ROUTE_EXERCISES_PROGRAMS,
  ROUTE_LOGOUT,
  ROUTE_REPORTS,
  ROUTE_USER_DOCUMENTS,
  ROUTE_USER_QUESTIONNAIRES
} from 'routes/RouteList';
const usePostMessage = () => {
  const [subject, setSubject] = useState([]);
  const [parsedMessage, setParsedMessage] = useState({});

  const history = useHistory();
  const validPaths = ['/documents', '/programs', '/reports', '/questionnaires'];

  const sendMessage = message => {
    window.parent.postMessage(
      { message: JSON.stringify(message) },
      getParentUrl()
    );
  };

  const onMessage = event => {
    authStoreChecker();
    if (event.origin === getParentUrl()) {
      try {
        let parsedMessage = [];

        if (typeof event.data?.message === 'string') {
          parsedMessage = JSON.parse(event.data.message);
        } else if (Array.isArray(event.data?.message)) {
          parsedMessage = event.data.message;
        } else {
          throw new Error('Message is not in expected format');
        }

        const subjectValue = parsedMessage.find(
          item => item.key === 'subject'
        )?.value;
        setSubject(subjectValue);
        setParsedMessage(parsedMessage);
        processMessage(parsedMessage);
      } catch (error) {
        console.error('Invalid JSON received:', event.data, error);
      }
    }
  };
  const processMessage = parsedMessage => {
    if (typeof parsedMessage !== 'undefined') {
      let message = {
        value: '',
        location: ''
      };
      message.value = Array.isArray(parsedMessage)
        ? parsedMessage.find(item => item.key === 'subject')?.value
        : undefined;

      if (message.value === 'unauthorized') {
        message.location = Array.isArray(parsedMessage)
          ? parsedMessage.find(item => item.key === 'location')?.value
          : undefined;
        setLocalStorage(parsedMessage, message.location);
      }
      if (message.value === 'navigateBack') {
        const currentPath = history.location.pathname;
        let basePath = null;

        const programBetween = currentPath.match(
          /^\/programs\/([a-z0-9-]{36})\/([a-z0-9-]{36})\/exercises\/[a-z0-9-]{36}$/
        );

        if (programBetween) {
          basePath = `/programs/${programBetween[1]}/${programBetween[2]}`;
        }

        if (!basePath) {
          basePath = validPaths.find(base =>
            currentPath.startsWith(base + '/')
          );
        }

        if (basePath && currentPath !== basePath) {
          history.push(basePath);
        }
      }
      if (message.value === 'logout') {
        localStorage.setItem('logout', 'true');
        history.push(ROUTE_LOGOUT);
        const data = {
          subject: 'logout'
        };
        sendMessage({ message: data });
      }
    }
  };

  const setLocalStorage = (data, location) => {
    if (localStorage.getItem('processedUnauthorized') === 'true') {
      return;
    }
    localStorage.clear();
    if (Array.isArray(data)) {
      data.forEach(item => {
        localStorage.setItem(item.key, item.value);
      });
      localStorage.setItem('processedUnauthorized', 'true');
    }

    switch (location) {
      case '/documents':
        history.push(ROUTE_USER_DOCUMENTS);
        break;
      case '/programs':
        history.push(ROUTE_EXERCISES_PROGRAMS);
        break;
      case '/reports':
        history.push(ROUTE_REPORTS);
        break;
      case '/questionnaires':
        history.push(ROUTE_USER_QUESTIONNAIRES);
        break;
      default:
        history.push('/');
    }
    window.location.reload();
  };

  const addEventListener = (event, callback) => {
    window.addEventListener('message', onMessage);
  };

  const removeEventListener = (event, callback) => {
    window.removeEventListener('message', onMessage);
  };

  const removeHelperVariables = () => {
    localStorage.removeItem('processedUnauthorized');
    localStorage.removeItem('subject');
  };

  const authStoreChecker = () => {
    if (localStorage.length === 0) {
      return;
    }
    if (
      !localStorage.getItem('authStore') ||
      localStorage.getItem('authStore') === '{}'
    ) {
      localStorage.clear();
      return;
    }
  };

  return {
    parsedMessage,
    removeHelperVariables,
    sendMessage,
    addEventListener,
    removeEventListener,
    processMessage,
    authStoreChecker
  };
};

export default usePostMessage;
